import { Constants } from "./client-constants";
import { ApiRoutes, AppRoutes } from "./routes";

type RouteInstance = string | ApiRoutes | AppRoutes; 

export function resolveRoute(route: RouteInstance, ...pathParams: string[]) {
    let calculatedPath: string = route;
    if (pathParams.length) {
        calculatedPath = route.replace(/{}/g, () => pathParams.shift() as string);;
    }

    return `${Constants.BasePath}${calculatedPath}`;
}

export function resolvePublicAssetPath(assetName: string): string {
  return `${Constants.BasePath}/${assetName}`;
}